import { ROUTES } from './routes';

export const ROUTE_TITLES = {
  // Core routes
  [ROUTES.HOME]: 'Tableau de bord',
  [ROUTES.BLOCKED_ACCESS]: 'Accès bloqué',
  [ROUTES.LOGOUT]: 'Déconnexion',

  // External Links
  [ROUTES.EXTERNAL_CONFORMITE]: 'Conformité',
  [ROUTES.EXTERNAL_MY_INFORMATION]: 'Mes informations',
  [ROUTES.EXTERNAL_MY_SUBSCRIPTIONS]: 'Mes abonnements',

  // Payment
  [ROUTES.PAYMENT_CHECKOUT]: 'Finaliser votre abonnement',

  // Setup module
  [ROUTES.SETUP_DASHBOARD]: 'Paramètres',
  [ROUTES.SETUP_SIMPLIFIED_DASHBOARD]: 'PARAMÉTRAGE DE VOTRE COMPTE',
  [ROUTES.SETUP_COPRO_AREA]: 'Surface des copropriétés',
  [ROUTES.SETUP_ADD_COLLABORATORS]: 'Attribution des collaborateurs',
  [ROUTES.SETUP_CONFIGURE_NOTIFICATIONS]: 'Configuration des alertes',
  [ROUTES.SETUP_BRANDING]: 'Personnalisation de la marque',
  [ROUTES.SETUP_MAIL_CONFIG]: 'Configuration de vos mails',
  [ROUTES.SETUP_SENT_MAILS]: 'Historique des emails envoyés',
  [ROUTES.SETUP_TRANSACTION_QUALIFICATION]: 'Qualification de l\'activité',
  [ROUTES.SETUP_NAF_EXCLUSION]: 'Surveillance exclusion assurance (code NAF)',
  
  // Analyzing module
  [ROUTES.ANALYZING_DASHBOARD]: 'Analyse du parc',
  [ROUTES.ANALYZING_VERIFY_COPROPRIETES]: 'Validation des copropriétés',
  [ROUTES.ANALYZING_ADD_COPROPRIETES]: 'Ajout des copropriétés',
  [ROUTES.ANALYZING_ADD_ADDRESSES]: 'Vérification des adresses',
  [ROUTES.ANALYZING_MARKET_VISION]: 'Vision du parc',
  // unreferenced routes here to be accessed in the future
  [ROUTES.ANALYZING_COPRO_MANAGING]: 'Gestion des copropriétés',
  [ROUTES.ANALYZING_COPRO_MANAGING_ID]: 'Détail de la copropriété',
  [ROUTES.ANALYZING_GENERATE_SALES_REPORT]: 'Rapport des ventes',
  [ROUTES.ANALYZING_COPRO_VIGILANCE]: 'Vigilance copropriétés',
  [ROUTES.ANALYZING_GESTIONNAIRES_COPROS]: 'Répartition des gestionnaires',
  [ROUTES.ANALYZING_GENERATE_COPRO_REPORT]: 'Rapport de copropriété',
  
  // Communication module
  [ROUTES.COMMUNICATION_DASHBOARD]: 'Communication',
  [ROUTES.COMMUNICATION_NEWSLETTER_LIST]: 'Newsletters',
  [ROUTES.COMMUNICATION_NEWSLETTER_TEMPLATE_SELECTION]: 'Choix du modèle de newsletter',
  [ROUTES.COMMUNICATION_NEWSLETTER_PREVIEW]: 'Aperçu de la newsletter',
  [ROUTES.COMMUNICATION_PAGE_SITE]: 'Page à inclure',
  [ROUTES.COMMUNICATION_REFERENT_CAMPAIGNS]: 'Communication Référent Mutation Location',
  [ROUTES.COMMUNICATION_REFERENT_FORMATION]: 'Formation Référent Mutation Location',
  [ROUTES.COMMUNICATION_SCI_UNSUBSCRIBERS]: 'Communication — Désinscriptions SCI',
  [ROUTES.COMMUNICATION_BUILDING_SALE_BOITAGE]: 'Biens à vendre — Modèles Boîtage',
  [ROUTES.COMMUNICATION_GENERAL_ASSEMBLY_MANAGER]: 'Assemblée générale',
  [ROUTES.COMMUNICATION_GENERAL_ASSEMBLY_REFERENT]: 'Assemblée générale',
  
  // Prospecting module
  [ROUTES.PROSPECTING_DASHBOARD]: 'Prospection',
  [ROUTES.PROSPECTING_COPRO_DETAILED_LIST]: 'Fiche détaillée de vos copropriétés',
  [ROUTES.PROSPECTING_NEW_OPPORTUNITIES]: 'Nouvelles opportunités (DPE)',
  // [ROUTES.PROSPECTING_IDENTIFIED_OWNER]: 'Propriétaires identifiés',
  [ROUTES.PROSPECTING_COMMUNICATE]: 'Communication aux propriétaires',
  [ROUTES.PROSPECTING_TRANSACTION]: 'Rendez-vous pour de la transaction',
  [ROUTES.PROSPECTING_RENTAL]: 'Rendez-vous pour de la gestion locative',
  [ROUTES.PROSPECTING_TEAM_PERFORMANCE]: 'Performance de l\'équipe',
  [ROUTES.PROSPECTING_DPE_VISION]: 'Vision des DPEs',
  [ROUTES.PROSPECTING_GENERATE_DPE_REPORT]: 'Rapport des DPEs',
  [ROUTES.PROSPECTING_COPRO_DETAILED_LIST]: 'Immeubles fort potentiel pour le boitage',
  [ROUTES.PROSPECTING_COPRO_KEY_FIGURES]: 'Les chiffres clés de mes copropriétés',
  [ROUTES.PROSPECTING_BOITAGE_QUALIFICATION]: 'Qualification boîtage',
  [ROUTES.PROSPECTING_BOITAGE_TRANSACTION]: 'Boîtage transaction',
  [ROUTES.PROSPECTING_SCIS_TRANSACTION]: 'Communication bien à vendre',
  [ROUTES.PROSPECTING_SCIS_RENT]: 'SCI — Prospection gestion locative',
  [ROUTES.PROSPECTING_SCIS_REFERENT]: 'SCI — Prospection globale référent',
  [ROUTES.REFERENT_APPOINTMENTS]: 'Rendez-vous appels entrants',
  [ROUTES.REFERENT_APPOINTMENTS_NEW]: 'Appels entrants — Nouveau RDV',
  [ROUTES.REFERENT_APPOINTMENTS_SCHEDULED]: 'Appels entrants — RDV programmés',
  [ROUTES.REFERENT_APPOINTMENTS_TRACKING]: 'Appels entrants — Suivi & Contrôle',
  [ROUTES.REFERENT_APPOINTMENTS_TEMPLATE_CLIENT]: 'Appels entrants — Modèle client',
  [ROUTES.REFERENT_APPOINTMENTS_TEMPLATE_COLLAB]: 'Appels entrants — Modèle collaborateur',
  [ROUTES.REFERENT_APPOINTMENTS_TEMPLATE_RELANCE]: 'Appels entrants — Modèle relance',
  [ROUTES.REFERENT_APPOINTMENTS_TEAM_SALES]: 'Appels entrants — Équipe Transaction',
  [ROUTES.REFERENT_APPOINTMENTS_TEAM_RENTAL]: 'Appels entrants — Équipe Location',
  [ROUTES.REFERENT_APPOINTMENTS_TEAM_PLANNING]: 'Appels entrants — Planning & Disponibilités',

  // Monitoring module
  [ROUTES.MONITORING_DASHBOARD]: 'Surveillance',
  [ROUTES.MONITORING_BAUX_COMMERCIAUX]: 'Sociétés / Commerces / Pieds d\'immeubles',
  [ROUTES.MONITORING_BAUX_A_ECHEANCE]: 'Baux à échéance',
  [ROUTES.MONITORING_BAUX_COMMERCIAUX_COPRO]: 'Baux commerciaux par copropriété',
  [ROUTES.MONITORING_ENTREPRISES_EN_DEFAILLANCE]: 'Commerces et sociétés (surveillance)',
  [ROUTES.MONITORING_ENTREPRISES_SUIVIES]: 'Surveillance gestion locative',
  [ROUTES.MONITORING_SCIS]: 'SCIs dans vos copros',
  [ROUTES.MONITORING_SCIS_SIREN]: 'Détail SCI',
  [ROUTES.MONITORING_SCIS_OVERALL]: 'SCI — Prospection globale',
  [ROUTES.MONITORING_INSURANCE_EXCLUSIONS]: 'Surveillance exclusion assurance (code NAF)',

  // Admin module
  [ROUTES.ADMIN_DASHBOARD]: 'Admin',
  [ROUTES.ADMIN_SOFTWARE_IMPORT]: 'Import Logiciel Métier',
  [ROUTES.ADMIN_SCI_CONTACT_IMPORT]: 'Import contacts SCI',
  [ROUTES.ADMIN_IMPORT_HISTORY]: 'Imports effectués',
  [ROUTES.ADMIN_COMPANY_VERIFICATION]: 'Entreprises à valider',
  [ROUTES.ADMIN_COPRO_VALIDATION]: 'Validation des copropriétés',
  [ROUTES.ADMIN_COMPANIES_LIST]: 'Liste des entreprises',
  [ROUTES.ADMIN_CLIENTS_LIST]: 'Clients',
  [ROUTES.ADMIN_CLIENTS_PLANNING]: 'Planning clients',
  [ROUTES.ADMIN_CARD_HOLDERS_LIST]: 'Base des cartes pro',
  [ROUTES.ADMIN_COMPANY_DETAILS]: 'Détails de l\'entreprise',
  [ROUTES.ADMIN_SIRET_TRACKED_IMPORT]: 'Import des SIRETs suivis',
  [ROUTES.ADMIN_BLOG_POSTS]: 'Articles',
  [ROUTES.ADMIN_BLOG_POST_NEW]: 'Nouvel article',
  [ROUTES.ADMIN_BLOG_POST_EDIT]: 'Édition de l\'article',
  [ROUTES.ADMIN_NEWSLETTER]: 'Newsletters',
  [ROUTES.ADMIN_NEWSLETTER_SELECT_TYPE]: 'Sélection du type de newsletter',
  [ROUTES.ADMIN_NEWSLETTER_NEW_STRUCTURED]: 'Création de newsletter structurée',
  [ROUTES.ADMIN_NEWSLETTER_EDIT]: 'Édition de la newsletter',
  [ROUTES.ADMIN_NEWSLETTER_PREVIEW]: 'Prévisualisation de la newsletter',
  [ROUTES.ADMIN_PENDING_CONFIG_IMPORTS]: 'Imports de configuration en attente',

  // Croissance
  [ROUTES.CROISSANCE]: 'Présentation du module',

  // External Blog
  [ROUTES.EXTERNAL_BLOG]: 'Blog',
  [ROUTES.EXTERNAL_BLOG_POST]: 'Article',
};

